// Name of the colors -> https://www.color-name.com/
// For consistency use lowercase characters

export const COLORS = {
  antiFlashWhite3: '#f0f3f5',
  brandDark: '#0A3A84',
  brandExtraDark: '#000062',
  brandLightBlue: '#E8F5FF',
  brandMedium: '#0B63CE',
  eucalyptus: '#4cd4a9',
  grayLight: '#E4E4E7',
  grayLight50A: '#f4f5f780',
  grayMedium: '#565b61',
  grayMediumLight: '#e3e8ed',
  honeydew: '#e8faf3',
  errorIndicatorBackground: '#d44c4c',
  warningColor: '#ed6c02',
  warningLight: '#fff0e4',
} satisfies { [colorName: string]: string }
